import './Support.scss';

function Support() {
  return <div className='Support'>Підтримка</div>;
}
export default Support;
